SNI.Application.addModule('read-more', (context) => {
  const mName = 'read-more';
  const debug = context.getService('logger').create('module.' + mName);

  const defaults = {
    //String value within the link to expand the section
    expansionString: 'Read More',
    //String value within the link to collapse the section
    collapseString: 'Show Less',
    //CSS class to apply to the read more link
    expansionClass: 'read-more-link',
    //CSS class to apply to the show less link
    collapseClass: 'show-less-link',
    //CSS class to apply to the expanded section
    expandedClassForSection: 'expanded',
    //CSS class to apply to the collapsed section
    collapsedClassForSection: 'collapsed',
    //Optional selector fo expanding parent container if applicable
    expandParentContainerSelector: '',
    //Optional selector to scroll to instead of expanding
    scrollToSelector: '',
    //Optional transition time in milliseconds to wait before collapsing
    transitionMillis: 0,
  };

  let settings = Object.assign({}, defaults, context.getConfig());

  return {
    init() {
      debug.log(`init: ${mName}`);

      var collapsed = true;
      var shouldScrollToSelector = $(settings.scrollToSelector).length > 0;
      var expandedHeight = 0;

      //Insert the read more link
      var el = context.getElement();
      var initialContainerHeight = el.clientHeight;

      var toggleClass = function(className) {
        debug.log('Toggling class: ', className);
        el.className.includes(className) ?
          el.className = el.className.replace(` ${className}`, '') :
          el.className += ` ${className}`;
      };

      debug.log('Scroll Height: ', el.scrollHeight);
      debug.log('Client Height: ', el.clientHeight);
      if (el.scrollHeight <= el.clientHeight) {
        //No overflow so no need to add the read more link
        debug.log('No overflow detected, skipping read more link addition');
        return;
      }
      toggleClass(settings.collapsedClassForSection);

      const readMoreLink = document.createElement('a');
      readMoreLink.href = '#';
      readMoreLink.className = settings.expansionClass;
      readMoreLink.innerText = settings.expansionString;
      el.after(readMoreLink);

      readMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (collapsed) {
          if (shouldScrollToSelector) {
            //Scroll to the selector
            $(settings.scrollToSelector)[0]?.scrollIntoView({behavior: 'smooth', block: 'center'});
          } else {
            if ($(settings.expandParentContainerSelector).length > 0) {
              //Calculate the new height of the container
              const parentEl = $(settings.expandParentContainerSelector)[0];
              expandedHeight = el.scrollHeight - el.clientHeight;
              const newHeight = parentEl.scrollHeight + expandedHeight;
              parentEl.style.height = newHeight + 'px';
            }
            el.style.height = el.scrollHeight + 'px';
            //optional toggling of expand/collapsed class
            toggleClass(settings.collapsedClassForSection);
            toggleClass(settings.expandedClassForSection);
            readMoreLink.innerText = settings.collapseString;
            readMoreLink.className = settings.collapseClass;
            collapsed = false;
          }
        } else {
          //set back to initial height
          el.style.height = initialContainerHeight + 'px';
          toggleClass(settings.expandedClassForSection);
          if (settings.expandParentContainerSelector && expandedHeight) {
            //Calculate the new height of the container
            const parentEl = $(settings.expandParentContainerSelector)[0];
            if (parentEl) {
              const newHeight = parentEl.scrollHeight - expandedHeight;
              parentEl.style.height = newHeight + 'px';
            }
          }
          toggleClass(settings.collapsedClassForSection);
          //Collapse the section
          readMoreLink.innerText = settings.expansionString;
          readMoreLink.className = settings.expansionClass;
          collapsed = true;
        }
      });
    },
  };
});
